import React from "react";

const FullScreenModal = props =>
    <div className="modal fade modalbox" id="ModalBasic" tabIndex="-1" style={{ display: 'none' }} aria-hidden="true">
        <div className="modal-dialog" role="document">
            {props.children}
        </div>
    </div>

export default FullScreenModal